import { Browser, Element, Class, Events } from "@webhare-system/frameworks/mootools/core";
var $todd = require("./support");
var KeyboardBunny = require("@webhare-system/dom/keyboard");
var domscroll = require('@webhare-system/dom/scroll');
var domui = require('@webhare-system/internal/legacyui');
var domtools = require('@webhare-system/dom/tools');
var menu = require('@__webhareroot-tollium/web/ui/components/basecontrols/menu');
require("../common.lang.json");
var toddImages = require("./images");


/****************************************************************************************************************************
 *                                                                                                                          *
 *  TOLLIUM DESKTOP (TASKBAR, SHORTCUTS, ETC.)                                                                              *
 *                                                                                                                          *
 ****************************************************************************************************************************/


/****************************************************************************************************************************
 * The application tabs bar
 */

$todd.ApplicationBar = new Class(
{ Implements: [ Events ]
, node: null
, fixed_node: null
, dyn_node: null
, nav_node: null
, name: "(applicationbar)"
, apps: []
, shell: null
, apptabmenu: null
, appnavmenu: null
, scrollstate: null
, scrollstepscheduled: false
, appbarsymbol: 'tolliumAppBar'
, tabmodifier: ''

, initialize: function(shell, appbar)
  {
    this.shell = shell;
    this.node = appbar;
    appbar.store("todd", this);

    this.shell.addEvent("activateapp", this.updateActiveApp.bind(this));
    //$$('#dashboard').addEvent("wh-dashboard-activation", this.updateActiveApp.bind(this));
    this.node.addEvent("click:relay(div.t-apptab)", this.onTabClick.bind(this));
    this.node.addEvent("contextmenu:relay(div.t-apptab)", this.onTabContextMenu.bind(this));
    this.apptabmenu = new Element("ul");
    this.appnavmenu = new Element("ul");

    this.fixed_node = this.node.getElement(".t-apptabs__fixed");
    this.dyn_node = this.node.getElement(".t-apptabs__dynamic");
    this.dyn_content_node = this.dyn_node.getElement(".t-apptabs__content");
    this.nav_node = this.dyn_node.getElement(".t-apptabs__navtab");
    this.scroll_left_node = this.dyn_node.getElement(".t-apptabs__leftscroll");
    this.scroll_right_node = this.dyn_node.getElement(".t-apptabs__rightscroll");

    var navtab = this.dyn_node.querySelector(".t-apptabs__navtab");
    navtab.addEventListener("click", this._onNavMenuClick.bind(this));
    navtab.addEventListener("wh:menu-activateitem", this._onActivateTab.bind(this));

    this.scroll_left_node.addEvents(
      { "mouseover": this._scrollMouseOverLeft.bind(this)
      , "mouseout": this._scrollCancel.bind(this)
      });
    this.scroll_right_node.addEvents(
      { "mouseover": this._scrollMouseOverRight.bind(this)
      , "mouseout": this._scrollCancel.bind(this)
      });

    //allow keyboard events to manipulate the bar
    var keyprefix = Browser.platform == "mac" ? "Control+Shift+" : "Alt+Shift+";
    var keymap = {};
    keymap[keyprefix + "ArrowLeft"] = this._gotoApp.bind(this,'relative',-1);
    keymap[keyprefix + "ArrowRight"] = this._gotoApp.bind(this,'relative',+1);

    [1,2,3,4,5,6,7,8,9,0].forEach(function(key, idx)
    {
      keymap[keyprefix + key] = this._gotoApp.bind(this,'absolute',idx);
    }, this);

    //Implement arrowleft,right etc
    new KeyboardBunny(document.body, keymap, { stopmapped:true });

    // Catch (shift+)backspace and cmd+left/right - it's okay to send to an input, but not to propagate it, to prevent
    // accidental browser navigation (allow stuff like ctrl+[ and cmd+])
    new KeyboardBunny(document.body, { "Backspace": function() {}
                                     , "Shift+Backspace": function() {}
                                     , "Accel+ArrowLeft": function() {}
                                     , "Accel+ArrowRight": function() {}
                                     }, { ignoreformfields: true, stopmapped: true});

    this._resize();
    shell.addEvent("desktopresized", this._resize.bind(this));
  }

, _scrollCancel: function()
  {
    this.scrollstate = null;
  }
, _scrollMouseOverLeft: function(event)
  {
    this.scrollstate =
        { time: Date.now()
        , start: this.dyn_content_node.scrollLeft
        , isleft: true
        };
    this._handleScrollStep();
    event.stop();
  }
, _scrollMouseOverRight: function(event)
  {
    this.scrollstate =
        { time: Date.now()
        , start: this.dyn_content_node.scrollLeft
        , isleft: false
        };
    this._handleScrollStep();
    event.stop();
  }
, _calcScrollDistance: function()
  {
    var speed = 400; // pixels per second
    var acctime = 2; // accelerate to final speed in this much seconds (normal acceleration)
    var timediff = (Date.now() - this.scrollstate.time) / 1000;

    var accphasepart = timediff > acctime ? 2 : timediff;
    var accphase = .5*(speed/acctime)*accphasepart*accphasepart;
    var linearphase = speed * (timediff - accphasepart);

    return accphase + linearphase;
  }
, _handleScrollStep: function(from_raf)
  {
    if (from_raf)
      this.scrollstepscheduled = false;
    if (!this.scrollstate)
      return;

    var dist = this._calcScrollDistance();
    this.dyn_content_node.scrollLeft = this.scrollstate.start + (this.scrollstate.isleft ? -1 : 1) * dist;
    this._resize();

    if (this.scrollstate)
    {
      this.scrollstepscheduled = true;
      requestAnimationFrame(this._handleScrollStep.bind(this, true));
    }
  }

, _onNavMenuClick: function(event)
  {
    this.appnavmenu.empty();

    // Add all apps (first the fixed apps, then the unfixed ones)
    this.apps.forEach(function(item) { if (item.fixed) this.appnavmenu.appendChild(item.menuitem); }.bind(this));
    this.apps.forEach(function(item) { if (!item.fixed) this.appnavmenu.appendChild(item.menuitem); }.bind(this));

    menu.openAt(this.appnavmenu, this.nav_node, { direction: 'down', align: 'right' });
  }

, _onActivateTab: function(event)
  {
    event.detail.menuitem.todd_app.activateApp();
    event.stopPropagation();
  }

, _gotoApp:function(how, idx)
  {
    if(how == 'relative')
    {
      var appidx = this.apps.indexByProperty('app', $todd.getActiveApplication());
      if(appidx < 0)
        return;

      var gotoappidx = (appidx + this.apps.length + idx) % this.apps.length;
      this.apps[gotoappidx].app.activateApp();
    }
    else if(how == 'absolute')
    {
      if(idx < this.apps.length)
        this.apps[idx].app.activateApp();
    }
  }

  // shortcut.app Application object
  // shortcut.icononly Only show icon (e.g. for homescreen app)
  // shortcut.countbadge Number to display in a badge over the icon
, toggleShortcut: function(app, show, fixed)
  {
    var appidx = this.apps.indexByProperty('app', app);
    fixed = fixed || false;

    if(show)
    {
      var newtab;
      if(appidx < 0)
      {
        // New application
        newtab = { close: domtools.create('span', {className:"t-apptab__close"})
                 , title: domtools.create('span', {className:"t-apptab__title"})
                 , icon: toddImages.createImage(app.appicon || 'tollium:tollium/tollium', app.appiconwidth || 16, app.appiconheight || 16, 'w', { className: "t-apptab__icon" })
                 , countbadge: domtools.create('span', {className:"t-apptab__countbadge", style:{display:"none"}})
                 };
        newtab.root = domtools.create('div', { className:"t-apptab t-apptab--hasicon"
                                             , childNodes:[newtab.icon,newtab.close,newtab.title,newtab.countbage]
                                             , on: { "wh:menu-activateitem": event => this.onTabContextMenuClick(app,event) }
                                             });
        newtab.root[this.appbarsymbol] = { tabmodifier: ''
                                         };
        newtab.onupdatescreen = this.onUpdateScreen.bind(this, newtab);
        newtab.onupdateapp = this.onUpdateApp.bind(this, newtab);
        newtab.app = app;
        newtab.title.set("text", app.title);
        newtab.root.store("tab", newtab);
        newtab.menuitem = new Element("li", { text: app.title });
        newtab.menuitem.todd_app = app;
        newtab.fixed = fixed;

        app.addEvent("updatescreen", newtab.onupdatescreen);
        app.addEvent("updateapp", newtab.onupdateapp);
      }
      else
      {
        // Already exists
        newtab = this.apps[appidx];

        // If not changed from fixed<->dynamic, we're done
        if (newtab.fixed == fixed)
          return;

        newtab.fixed = fixed;

        // Reinsert the app, so the ordering within fixed/non-fixed classes stays ok
        this.apps.splice(appidx, 1);
      }

      this.apps.push(newtab);

      // (re-)insert at the right nav node
      if (fixed)
        this.fixed_node.appendChild(newtab.root);
      else
        this.dyn_content_node.appendChild(newtab.root);
    }
    else
    {
      if(appidx < 0)
        return;

      var tab = this.apps[appidx];
      app.removeEvent("updatescreen", tab.onupdatescreen);
      app.removeEvent("updateapp", tab.onupdateapp);
      tab.root.destroy();
      this.apps.splice(appidx, 1);
    }

    this._recalculateCSSClasses();

    this._resize();
  }

, _recalculateCSSClasses: function()
  {
    //var allnodes = Array.slice(this.node.querySelectorAll(":scope > div > div.apptab"));
    var allnodes = Array.slice(this.node.getElements(".t-apptab"));

    allnodes.forEach(function(item, idx)
    {
      item.toggleClass("t-apptab--first", idx == 0);
      item.toggleClass("t-apptab--last", idx == allnodes.length-1);
      item.toggleClass("t-apptab--prevactiveapp", idx != 0 && allnodes[idx-1].hasClass("t-apptab--activeapp"));
    });
  }

, _resize: function()
  {
    var total_width = this.node.parentNode.offsetWidth;
    var fixed_width = this.fixed_node.offsetWidth;
    var dyn_scroll_pos = this.dyn_content_node.scrollLeft;
    var nav_width = this.nav_node.offsetWidth;

    // Calc the requested width from the width of the content
    var dyn_scroll_width = 0;
    if (this.dyn_content_node.lastChild)
      dyn_scroll_width = this.dyn_content_node.lastChild.offsetLeft + this.dyn_content_node.lastChild.offsetWidth;

    var dyn_width = total_width - fixed_width;
    var overflow = dyn_scroll_width > dyn_width;
    var dyn_content_width = dyn_width - (overflow ? nav_width : 0);

    var can_scroll_left = dyn_scroll_pos != 0;
    var can_scroll_right = dyn_scroll_width - dyn_content_width - dyn_scroll_pos >= 1;

    this.dyn_node.setStyles({ left: fixed_width, width: dyn_width });
    this.dyn_content_node.setStyles({ width: dyn_content_width });
    //this.nav_node.setStyles({ left: dyn_content_width });

//    this.dyn_node.querySelector(":scope > span.t-apptabs__dynamic__leftscroll").toggleClass("t-apptabs__dynamic__leftscroll-visible", can_scroll_left);
//    this.dyn_node.querySelector(":scope > span.t-apptabs__dynamic__rightscroll").toggleClass("t-apptabs__dynamic__rightscroll-visible", can_scroll_right);
    this.node.toggleClass("t-apptabs--canscrollleft", can_scroll_left);
    this.node.toggleClass("t-apptabs--canscrollright", can_scroll_right);

    if (this.scrollstate)
    {
      if (!can_scroll_left && this.scrollstate.isleft)
        this.scrollstate = null;
      if (!can_scroll_right && !this.scrollstate.isleft)
        this.scrollstate = null;
    }
  }

, updateActiveApp:function(event)
  {
    this.node.setStyle("display", this.anyShortcuts() ? "block" : "none");
    for(let appnode of this.node.querySelectorAll(".t-apptab--activeapp"))
      appnode.classList.remove("t-apptab--activeapp");

    var appidx = this.apps.indexByProperty('app', $todd.getActiveApplication());
    if(appidx >= 0)
    {
      this.apps[appidx].root.classList.add("t-apptab--activeapp");

      // Scroll to active node
      try
      {
        domscroll.scrollToElement(
            this.apps[appidx].root,
            { limitnode: this.node
            , allownodes: [ this.dyn_content_node ]
            , context: "0 50px"
            });
      }
      catch(e)
      {
        console.warn("scrolltoelement fail", e);
      }
      this.scrollstate = null;

      this._resize();
    }
    this._recalculateCSSClasses();
  }
, onTabClick:function(event, tabnode)
  {
    var app = tabnode.retrieve("tab").app;
    app.activateApp();
    if(event.target.getSelfOrParent(".t-apptab__close")) //it's the closer being clicked
      app.requestClose();
  }
, onTabContextMenu:function(event, tabnode)
  {
    if (domui.isAllowNativeContextMenu(event))
      return;

    event.stop();

    var app = tabnode.retrieve("tab").app;
    if(!app)
      return;

    var appmenu = app.generateAppMenu();

    this.apptabmenu.empty();
    appmenu.each(function (menuitem)
    {
      this.apptabmenu.adopt(new Element("li", { "text": menuitem.title
                                              }).store("menuitem", menuitem));
    }.bind(this));

    menu.openAt(this.apptabmenu, event);
  }
, onTabContextMenuClick:function(app, event)
  {
    var action = event.detail.menuitem.retrieve("menuitem");
    if(action && action.cmd)
      app.executeCommand(action.cmd);
  }
, onUpdateScreen: function(tab, event)
  {
   if(event.screen.parentwindow == null) //we only honor updates from the toplevel screen
      tab.root.toggleClass("t-apptab--allowclose", event.allowclose);
  }
, onUpdateApp: function(tab, event)
  {
    tab.root.toggleClass('t-apptab--hasicon', !!tab.app.appicon);
    tab.root.toggleClass('t-apptab--hasissues', tab.app.hasissues);
    tab.root.toggleClass('t-apptab--isdebugged', tab.app.isdebugged);
    if(tab.root[this.appbarsymbol].tabmodifier != tab.app.tabmodifier)
    {
      if(tab.root[this.appbarsymbol].tabmodifier)
        tab.root.classList.remove('t-apptab--' + tab.root[this.appbarsymbol].tabmodifier);
      if(tab.app.tabmodifier)
        tab.root.classList.add('t-apptab--' + tab.app.tabmodifier);
      tab.root[this.appbarsymbol].tabmodifier = tab.app.tabmodifier;
    }

    if (tab.app.appicon)
      toddImages.updateImage(tab.icon, tab.app.appicon, tab.app.appiconwidth, tab.app.appiconheight, 'w');
    tab.title.set('text', tab.app.title);
    tab.menuitem.set('text', tab.app.title);
    this.appnavmenu.fireEvent("wh-refresh");
    //tab.root.toggleClass("allowclose", event.allowclose);
    this._resize();
  }
, anyShortcuts:function()
  {
    return this.apps.length>0;
  }
});

$todd.applicationBar = null;



// WEBPACK FOOTER //
// /opt/wh/whtree/modules/tollium/web/ui/js/desktop.es